import React, { useEffect, useState } from "react";
import "./addInstructor.scss";
import Grid from "@mui/material/Unstable_Grid2";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Dropdown from "../../components/common/Dropdown";
import { getTimezoneOption } from "../../globals/common_utilities/timezoneListing";
import InputTags from "../common/InputTags";
import { Redux_training_centre_list } from "../../redux/forms/index";
import { Redux_addInstructor } from "../../redux/forms/addInstructior";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  isEmpty,
  validateEmail,
  validatePhone,
  validateName,
  validateScript,
  validateSkills,
} from "../../globals/common_utilities/utilities";
import MultiLine_Spinner from "../multiline_spinner/Multiline_spinner";
import { API, FOMRS, ROLE, APP_ROUTES } from "../../globals/constants";
import api_call from "../../globals/common_utilities/axios_old";
import EDIT from "../../Images/formEdit.png";
import CONSTANTURL from "../../globals/common_utilities/constanturls";
import Cookies from "universal-cookie";
import { Stack } from "@mui/material";
import { Tooltip } from "@mui/material";
import Info from "../../Images/yellow_info_icon.svg";

const AddInstructor = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [showLoader, setShowLoader] = useState(false);
  const { state } = useLocation();
  const [editCheckbox, setEditCheckbox] = useState(false);
  const { loginResponse, loading, error } = useSelector((state) => {
    return state.login;
  });
  const cookies = new Cookies();
  const {
    id,
    name,
    device_id,
    studio_id,
    role_id,
    role_code,
    token,
    token_uniq_id,
    email_id,
    username,
    is_email_verify,
  } = cookies.get("loginData");
  const api_res = useSelector((state) => {
    return state.addInstructor?.Response;
  });

  const [getTimeZoneList, setTimeZoneList] = useState();
  const [instructor_id, setInstructor_id] = useState(
    state?.id || "36af5911-3f8e-454c-98b2-59d12d12b9d7"
  );
  const [type, setType] = useState(state?.type || FOMRS.ADD);
  const [roleid, setRole_id] = useState(3);
  const [traininig_center_list, setTraining_center_list] = useState([]);

  const [formField, setFormField] = useState({
    instructor_name: "",
    contact_no: "",
    email_id: "",
    username: "",
    about_Instructor: "",
    time_zone: "",
    Training_center_name: "",
    skills: "",
    instructor_can_be_training_admin_checkbox: false,
  });
  const [formField_error, setFormFild_error] = useState({
    instructor_name_error: false,
    contact_no_error: false,
    email_id_error: false,
    username_error: false,
    about_Instructor_error: false,
    time_zone_error: false,
    Training_center_name_error: false,
    skills_error: false,
  });

  const TimeZoneFun = async () => {
    let timezone = await getTimezoneOption();
    console.log("cbbcnbcnx----", timezone);
    setTimeZoneList(timezone);
  };

  const traininingCenterFun = async () => {
    if (role_code === ROLE.ADMIN) {
      const Response = await api_call(
        "GET",
        `${
          CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].STUDIO +
          API.END_POINTS.STUDIO_LIST
        }`,
        {
          is_active: true,
        }
      );
      if (Response.status === 200) {
        setTraining_center_list(
          Response.data?.data?.rows.map((value) => ({
            id: value.id,
            value: value.id,
            label: value.studio_name,
          }))
        );
      }
    } else {
      const Response = await api_call(
        "GET",
        `${
          CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].STUDIO +
          API.END_POINTS.STUDIO_LIST
        }`,
        {
          is_active: true,
          studio_id: studio_id,
        }
      );
      if (Response.status === 200) {
        setTraining_center_list(
          Response.data?.data?.rows.map((value) => ({
            id: value.id,
            value: value.id,
            label: value.studio_name,
          }))
        );
      } else {
        setTraining_center_list([]);
      }
    }
  };

  const viewForm = async () => {
    let params = { id: instructor_id };
    setShowLoader(true);
    const { status, data } = await api_call(
      "GET",
      `${
        CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].LOGIN +
        API.END_POINTS.VIEW_INSTRUCTOR
      }`,
      params
    );
    if (status === 200) {
      setShowLoader(false);
      setFormField({
        ...formField,
        instructor_name: data?.data?.name,
        Training_center_name: data?.data?.studio_id,
        contact_no: data?.data?.contact_no,
        email_id: data?.data?.email_id,
        time_zone: data?.data?.zone,
        skills: data?.data?.skills ? JSON.parse(data?.data?.skills) : [],
        username: data?.data?.username,
        instructor_can_be_training_admin_checkbox:
          data?.data?.instructor_as_studio,
        about_Instructor: data?.data?.short_information,
      });
    } else {
      setTraining_center_list([]);
    }
  };
  useEffect(() => {
    TimeZoneFun();
    traininingCenterFun();
    if (type === "VIEW" || type === "EDIT") viewForm();
  }, []);

  const isValid = () => {
    if (role_code === "STUDIO_ADMIN") {
      if (
        !isEmpty(formField.instructor_name) &&
        formField.instructor_name.trim().length !== 0 &&
        !isEmpty(formField.username) &&
        formField.username.trim().length !== 0 &&
        !isEmpty(formField.email_id) &&
        formField.email_id.trim().length !== 0 &&
        formField.skills?.length !== 0 &&
        !isEmpty(formField.time_zone) &&
        validateEmail(formField.email_id) &&
        validateSkills(formField.skills) &&
        validateScript(formField.instructor_name) &&
        validateScript(formField.username) &&
        validateScript(formField.email_id) &&
        validateScript(formField.time_zone)
      ) {
        return true;
      } else if (formField.instructor_can_be_training_admin_checkbox === true) {
        if (
          !isEmpty(formField.instructor_name) &&
          formField.instructor_name.trim().length !== 0 &&
          !isEmpty(formField.username) &&
          formField.username.trim().length !== 0 &&
          !isEmpty(formField.email_id) &&
          formField.email_id.trim().length !== 0 &&
          formField.skills?.length !== 0 &&
          !isEmpty(formField.time_zone) &&
          validateEmail(formField.email_id) &&
          validateSkills(formField.skills) &&
          validateScript(formField.username) &&
          validateScript(formField.email_id) &&
          validateScript(formField.instructor_name) &&
          validateScript(formField.time_zone)
        ) {
          return true;
        } else {
          return false;
        }
      }
      return false;
    } else {
      if (
        !isEmpty(formField.instructor_name) &&
        formField.instructor_name.trim().length !== 0 &&
        !isEmpty(formField.username) &&
        formField.username.trim().length !== 0 &&
        !isEmpty(formField.Training_center_name) &&
        !isEmpty(formField.email_id) &&
        formField.email_id.trim().length !== 0 &&
        formField.skills?.length !== 0 &&
        !isEmpty(formField.time_zone) &&
        validateEmail(formField.email_id) &&
        validateSkills(formField.skills) &&
        validateScript(formField.instructor_name) &&
        validateScript(formField.username) &&
        validateScript(formField.email_id) &&
        validateScript(formField.Training_center_name) &&
        validateScript(formField.time_zone)
      ) {
        return true;
      } else if (formField.instructor_can_be_training_admin_checkbox === true) {
        if (
          !isEmpty(formField.instructor_name) &&
          formField.instructor_name.trim().length !== 0 &&
          !isEmpty(formField.username) &&
          formField.username.trim().length !== 0 &&
          !isEmpty(formField.Training_center_name) &&
          !isEmpty(formField.email_id) &&
          formField.email_id.trim().length !== 0 &&
          formField.skills?.length !== 0 &&
          !isEmpty(formField.time_zone) &&
          validateEmail(formField.email_id) &&
          validateSkills(formField.skills) &&
          validateScript(formField.username) &&
          validateScript(formField.Training_center_name) &&
          validateScript(formField.email_id) &&
          validateScript(formField.instructor_name) &&
          validateScript(formField.time_zone)
        ) {
          return true;
        } else {
          return false;
        }
      }
      return false;
    }
  };

  const getToster = (res) => {
    console.log("res.data.msg-------->>", res);
    if (res.status == 200) {
      if (type === FOMRS.ADD) {
        toast.success("Instructor created successfully", {
          position: "bottom-right",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          style: { background: "#000", color: "#ffffff" },
        });
      } else {
        toast.success("Instructor updated successfully", {
          position: "bottom-right",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          style: { background: "#000", color: "#ffffff" },
        });
      }

      gotolistingPage();
    } else if (res?.status == 409) {
      toast.error(res?.err?.data?.msg?.msg, {
        position: "bottom-right",
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        style: { background: "#000", color: "#ffffff" },
      });
    } else {
      toast.error(`something went wrong!`, {
        position: "bottom-right",
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        style: { background: "#000", color: "#ffffff" },
      });
    }
  };

  const onSubmit = async () => {
    console.log("hit out");
    if (await isValid()) {
      console.log("hit in");
      let bodyParam =
        formField.instructor_can_be_training_admin_checkbox === true
          ? {
              name: formField.instructor_name,
              username: formField.username,
              email_id: formField.email_id,
              studio_id:
                role_code === "STUDIO_ADMIN"
                  ? studio_id
                  : formField.Training_center_name,
              role_id: roleid,
              contact_no: formField.contact_no,
              zone: formField.time_zone,
              skills: JSON.stringify([...formField.skills]),
              short_information: formField.about_Instructor,
              is_active: true,
              instructor_as_studio:
                formField.instructor_can_be_training_admin_checkbox,
            }
          : {
              name: formField.instructor_name,
              username: formField.username,
              email_id: formField.email_id,
              studio_id:
                role_code === "STUDIO_ADMIN"
                  ? studio_id
                  : formField.Training_center_name,
              role_id: roleid,
              contact_no: formField.contact_no,
              zone: formField.time_zone,
              skills: JSON.stringify([...formField.skills]),
              short_information: formField.about_Instructor,
              is_active: true,
            };

      if (type === FOMRS.ADD) {
        const createdBy = {
          id: id,
          name: name,
        };
        bodyParam.createdBy = createdBy;
      } else if (type === FOMRS.EDIT) {
        const updatedBy = {
          id: id,
          name: name,
        };
        bodyParam.updatedBy = updatedBy;
      }
      let response = "";
      if (role_code === ROLE.ADMIN) {
        if (type === FOMRS.ADD) {
          setShowLoader(true);
          response = await api_call(
            "POST",
            `${
              CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].LOGIN +
              API.END_POINTS.USERS
            }`,
            { flag: formField?.instructor_can_be_training_admin_checkbox },
            {},
            bodyParam
          );
        } else {
          setShowLoader(true);
          response = await api_call(
            "PUT",
            `${
              CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].LOGIN +
              API.END_POINTS.USERS
            }?id=${instructor_id}`,
            { flag: formField?.instructor_can_be_training_admin_checkbox },
            {},
            bodyParam
          );
        }
      } else if (role_code === ROLE.STUDIO_ADMIN) {
        if (type === FOMRS.ADD) {
          setShowLoader(true);
          response = await api_call(
            "POST",
            `${
              CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].LOGIN +
              API.END_POINTS.STUD_ADMIN
            }`,
            { flag: formField?.instructor_can_be_training_admin_checkbox },
            {},
            bodyParam
          );
        } else {
          setShowLoader(true);
          response = await api_call(
            "PUT",
            `${
              CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].LOGIN +
              API.END_POINTS.STUDIO_ADMIN
            }?id=${instructor_id}`,
            {},
            {},
            bodyParam
          );
        }
      }
      setShowLoader(false);
      getToster(response);
    } else {
      setFormFild_error(() => {
        return {
          ...formField_error,
          instructor_name_error:
            isEmpty(formField.instructor_name) ||
            formField.instructor_name.trim().length === 0 ||
            !validateScript(formField.instructor_name),
          Training_center_name_error:
            isEmpty(formField.Training_center_name) ||
            !validateScript(formField.Training_center_name),
          contact_no_error:
            isEmpty(formField.contact_no) ||
            formField.contact_no.trim().length === 0 ||
            !validatePhone(formField.contact_no) ||
            !validateScript(formField.contact_no),
          email_id_error:
            isEmpty(formField.email_id) ||
            formField.email_id.trim().length === 0 ||
            !validateEmail(formField.email_id) ||
            !validateScript(formField.email_id),
          about_Instructor_error:
            isEmpty(formField.about_Instructor) ||
            formField.about_Instructor.trim().length === 0 ||
            !validateScript(formField.about_Instructor),
          username_error:
            isEmpty(formField.username) ||
            formField.username.trim().length === 0 ||
            !validateScript(formField.username),
          time_zone_error:
            isEmpty(formField.time_zone) ||
            !validateScript(formField.time_zone),
          skills_error:
            formField.skills.length === 0 ||
            !validateScript(formField.skills) ||
            !validateSkills(formField.skills),
        };
      });
    }
  };

  const timezone_fun = (e) => {
    let data1 = e.value.split("$");
    console.log("formField---------", data1);
    setFormField({ ...formField, time_zone: data1[0] });
    setFormFild_error({
      ...formField_error,
      time_zone_error: false,
    });
  };
  const training_center_fun = (e) => {
    setFormField({ ...formField, Training_center_name: e.value });
    setFormFild_error({
      ...formField_error,
      Training_center_name_error: false,
    });
  };

  const gotolistingPage = (training) => {
    navigate(APP_ROUTES.ROUTE_INSTRUCTOR, {
      state: {},
    });
  };
  return (
    <>
      {console.log(
        "formField---------------->>",
        formField,
        getTimeZoneList?.filter((zone) => formField?.time_zone === zone?.key),
        getTimeZoneList
      )}
      <div className="mainContainer">
        {showLoader ? (
          <MultiLine_Spinner />
        ) : (
          <>
            <Grid
              container
              xs={12}
              sm={12}
              md={12}
              lg={12}
              className="TitleContainer"
              justifyContent={"space-between"}
            >
              <div>
                <span className="TitleName" onClick={gotolistingPage}>
                  {`Instructor >>`}
                </span>
                <span className="TrainingName">
                  {type === "ADD"
                    ? "Add "
                    : type === "EDIT"
                    ? "Edit "
                    : "View "}
                  Instructor
                </span>
              </div>
            </Grid>
            <Grid
              container
              columnSpacing={2}
              rowSpacing={1.5}
              className="parentContainer"
            >
              <Stack
                width="100%"
                justifyContent={"flex-end"}
                alignItems="flex-end"
              >
                {type !== "ADD" && (
                  <div
                    className={
                      editCheckbox
                        ? "edit-instructor-form active_class"
                        : "edit-instructor-form"
                    }
                  >
                    <img
                      src={EDIT}
                      width="55px"
                      height="55px"
                      onClick={(e) => {
                        setEditCheckbox(!editCheckbox);
                        setType(editCheckbox ? "VIEW" : "EDIT");
                      }}
                    />
                  </div>
                )}
              </Stack>
              <Grid Item xs={12} sm={12} md={6} lg={6} className="fieldDiv">
                <Grid container>
                  <Grid xs={12} sm={12} md={12} lg={12} className="formLabel">
                    Instructor Name
                  </Grid>
                  <Grid xs={11} sm={11} md={11} lg={11}>
                    <input
                      className="addTrainingInput"
                      placeholder="Unreal Authorised Instructor Name"
                      value={formField.instructor_name}
                      disabled={type === FOMRS.VIEW}
                      onChange={(e) => {
                        setFormField({
                          ...formField,
                          instructor_name: e.target.value,
                        });
                        setFormFild_error({
                          ...formField_error,
                          instructor_name_error: false,
                        });
                      }}
                    />
                    {formField_error.instructor_name_error && (
                      <small className="error small_f">
                        Enter Valid Instructor Name *
                      </small>
                    )}
                  </Grid>
                  <Grid item xs={1} sm={1} md={1} lg={1} xl={1}>
                    <div className="info_image">
                      <Tooltip
                        title="
                        This is the name of the Unreal Authorized Instructor (UAI). Example 'John Smith'"
                        placement="top-start"
                        arrow
                      >
                        <img src={Info} className="tooltip-align" />
                      </Tooltip>
                    </div>
                  </Grid>
                </Grid>
              </Grid>
              <Grid Item xs={12} sm={12} md={6} lg={6} className="fieldDiv">
                <Grid container>
                  <Grid xs={12} sm={12} md={12} lg={12} className="formLabel">
                    Training center Name
                  </Grid>
                  <Grid xs={11} sm={11} md={11} lg={11}>
                    <Dropdown
                      value={
                        role_code === "STUDIO_ADMIN"
                          ? traininig_center_list
                          : traininig_center_list?.filter(
                              (zone) =>
                                formField?.Training_center_name === zone?.value
                            )
                      }
                      isDisabled={
                        type === FOMRS.VIEW || role_code === "STUDIO_ADMIN"
                      }
                      clearable
                      options={traininig_center_list}
                      onChange={(e) => training_center_fun(e)}
                      selection
                      placeholder="Training Center Name"
                    />
                    {formField_error.Training_center_name_error && (
                      <small className="error small_f">
                        Please select training center Name *
                      </small>
                    )}
                  </Grid>
                  <Grid item xs={1} sm={1} md={1} lg={1} xl={1}>
                    <div className="info_image">
                      <Tooltip
                        title="
                        Please select Training center in which the instructor is associated with"
                        placement="top-start"
                        arrow
                      >
                        <img src={Info} className="tooltip-align" />
                      </Tooltip>
                    </div>
                  </Grid>
                </Grid>
              </Grid>

              {/* <Grid Item xs={12} sm={12} md={6} lg={6} className="fieldDiv">
                <Grid container>
                  <Grid xs={12} sm={12} md={12} lg={12} className="formLabel">
                    Contact No
                  </Grid>
                  <Grid xs={11} sm={11} md={11} lg={11}>
                    <input
                      disabled={type === FOMRS.VIEW}
                      className="addTrainingInput"
                      placeholder="Contact Number"
                      value={formField.contact_no}
                      onChange={(e) => {
                        setFormField({
                          ...formField,
                          contact_no: e.target.value,
                        });
                        setFormFild_error({
                          ...formField_error,
                          contact_no_error: false,
                        });
                      }}
                    />
                    {formField_error.contact_no_error && (
                      <small className="error small_f">
                        Enter valid Contact Number
                      </small>
                    )}
                  </Grid>
                  <Grid item xs={1} sm={1} md={1} lg={1} xl={1}>
                    <div className="info_image">
                      <Tooltip
                        title="
                        Please provide the contact number of the Unreal Authorized Instructor"
                        placement="top-start"
                        arrow
                      >
                        <img src={Info} className="tooltip-align" />
                      </Tooltip>
                    </div>
                  </Grid>
                </Grid>
              </Grid> */}
              <Grid Item xs={12} sm={12} md={6} lg={6} className="fieldDiv">
                <Grid container>
                  <Grid xs={12} sm={12} md={12} lg={12} className="formLabel">
                    Email ID
                  </Grid>
                  <Grid xs={11} sm={11} md={11} lg={11}>
                    <input
                      disabled={type === FOMRS.VIEW}
                      className="addTrainingInput"
                      placeholder="Email Address"
                      type="email"
                      value={formField.email_id}
                      onChange={(e) => {
                        setFormField({
                          ...formField,
                          email_id: e.target.value,
                        });
                        setFormFild_error({
                          ...formField_error,
                          email_id_error: false,
                        });
                      }}
                    />
                    {formField_error.email_id_error && (
                      <small className="error small_f">
                        Enter valid email address
                      </small>
                    )}
                  </Grid>
                  <Grid item xs={1} sm={1} md={1} lg={1} xl={1}>
                    <div className="info_image">
                      <Tooltip
                        title="
                        All communication regarding training activities concerning this instructor will be sent to this email ID. Please ensure this is a valid email ID."
                        placement="top-start"
                        arrow
                      >
                        <img src={Info} className="tooltip-align" />
                      </Tooltip>
                    </div>
                  </Grid>
                </Grid>
              </Grid>
              <Grid Item xs={12} sm={12} md={6} lg={6} className="fieldDiv">
                <Grid container>
                  <Grid xs={12} sm={12} md={12} lg={12} className="formLabel">
                    Time Zone
                  </Grid>
                  <Grid xs={11} sm={11} md={11} lg={11}>
                    <Dropdown
                      isDisabled={type === FOMRS.VIEW}
                      value={getTimeZoneList?.filter(
                        (zone) => formField?.time_zone === zone?.value
                      )}
                      clearable
                      options={getTimeZoneList}
                      selection
                      placeholder="Select &amp; Search Timezone"
                      onChange={(e) => timezone_fun(e)}
                    />
                    {formField_error.time_zone_error && (
                      <small className="error small_f">
                        Please select timezone *
                      </small>
                    )}
                  </Grid>
                  <Grid item xs={1} sm={1} md={1} lg={1} xl={1}>
                    <div className="info_image">
                      <Tooltip
                        title="
                        Select the nearest region to Unreal Authorized Instructor's location. This is only for self-reference and tagging purposes."
                        placement="top-start"
                        arrow
                      >
                        <img src={Info} className="tooltip-align" />
                      </Tooltip>
                    </div>
                  </Grid>
                </Grid>
              </Grid>
              <Grid Item xs={12} sm={12} md={6} lg={6} className="fieldDiv">
                <Grid container>
                  <Grid xs={12} sm={12} md={12} lg={12} className="formLabel">
                    Skills
                  </Grid>
                  <Grid xs={11} sm={11} md={11} lg={11}>
                    <InputTags
                      readOnly={type === FOMRS.VIEW}
                      placeholder="Add skills (eg: Gaming) &amp; hit enter"
                      tags={
                        formField?.skills.length > 0 &&
                        formField?.skills.map((data) => data)
                      }
                      onChange={(e) => {
                        setFormField({ ...formField, skills: e });
                        setFormFild_error({
                          ...formField_error,
                          skills_error: false,
                        });
                      }}
                    />
                    {formField_error.skills_error && (
                      <small className="error small_f">
                        Please enter skills *
                      </small>
                    )}
                  </Grid>
                  <Grid item xs={1} sm={1} md={1} lg={1} xl={1}>
                    <div className="info_image">
                      <Tooltip
                        title="
                        This tags what this Unreal Authorized Instructor is most skilled in teaching. Eg: If this instuctor primarily teaches game development, then add 'games' as the tag. You can add multiple tags. This is purely for self-reference purposes"
                        placement="top-start"
                        arrow
                      >
                        <img src={Info} className="tooltip-align" />
                      </Tooltip>
                    </div>
                  </Grid>
                </Grid>
              </Grid>
              <Grid Item xs={12} sm={12} md={6} lg={6} className="fieldDiv">
                <Grid container>
                  <Grid xs={11} sm={11} md={11} lg={11} className="formLabel">
                    Epic ID username
                  </Grid>
                  <Grid xs={11} sm={11} md={11} lg={11}>
                    <input
                      disabled={type === FOMRS.VIEW}
                      className="addTrainingInput"
                      placeholder="Epic username"
                      value={formField.username}
                      onChange={(e) => {
                        setFormField({
                          ...formField,
                          username: e.target.value,
                        });
                        setFormFild_error({
                          ...formField_error,
                          username_error: false,
                        });
                      }}
                    />
                    {formField_error.username_error && (
                      <small className="error small_f">
                        Enter Valid username *
                      </small>
                    )}
                  </Grid>
                  <Grid item xs={1} sm={1} md={1} lg={1} xl={1}>
                    <div className="info_image">
                      <Tooltip
                        title="
                        This connects Cumulo to the Unreal Authorized Instructor's Epic Games login. It's important to get this right. The instructor can get their 'Display Name' from their Epic Games account. Please ask them to go to https://www.epicgames.com/account/personal to see their Display Name. Display Name is case sensitive"
                        placement="top-start"
                        arrow
                      >
                        <img src={Info} className="tooltip-align" />
                      </Tooltip>
                    </div>
                  </Grid>
                </Grid>
              </Grid>
              <Grid Item xs={12} sm={12} md={12} lg={12} className="fieldDiv">
                <Grid
                  Item
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                  container
                  direction={"row"}
                  alignItems="center"
                >
                  <input
                    disabled={type === FOMRS.VIEW || type === FOMRS.EDIT}
                    type="checkbox"
                    onClick={() =>
                      setFormField({
                        ...formField,
                        instructor_can_be_training_admin_checkbox:
                          !formField.instructor_can_be_training_admin_checkbox,
                      })
                    }
                    style={{ width: "18px", height: "18px" }}
                    checked={
                      formField.instructor_can_be_training_admin_checkbox
                    }
                  />
                  <span className="addTrainingCheckbox">
                    Assign Instructor also as an Training Center admin ?
                  </span>
                </Grid>
              </Grid>
              {/* <Grid Item xs={12} sm={12} md={12} lg={12} className="fieldDiv">
                <Grid container>
                  <Grid xs={12} sm={12} md={12} lg={12} className="formLabel">
                    About Instructor
                  </Grid>
                  <Grid xs={11.5} sm={11.5} md={11.5} lg={11.5}>
                    <textarea
                      disabled={type === FOMRS.VIEW}
                      rows={5}
                      className="addTrainingTextarea"
                      placeholder="About Instructor"
                      value={formField.about_Instructor}
                      onChange={(e) => {
                        setFormField({
                          ...formField,
                          about_Instructor: e.target.value,
                        });
                        setFormFild_error({
                          ...formField_error,
                          about_Instructor_error: false,
                        });
                      }}
                    />
                    {formField_error.about_Instructor_error && (
                      <small className="error small_f">
                        Please fill this field *
                      </small>
                    )}
                  </Grid>
                  <Grid item xs={0.5} sm={0.5} md={0.5} lg={0.5} xl={0.5}>
                    <div className="info_image">
                      <Tooltip
                        title="
                        Please provide a brief info about the Unreal Authorized Instructor. Eg: 'John Smith primarily teaches game development and has over 8 years of teaching experience'"
                        placement="top-start"
                        arrow
                      >
                        <img src={Info} className="tooltip-align" />
                      </Tooltip>
                    </div>
                  </Grid>
                </Grid>
              </Grid> */}

              <Grid Item xs={12} sm={12} md={12} lg={12} className="fieldDiv">
                <Grid xs={12} sm={12} md={12} lg={12} className="formLabel">
                  {type === "EDIT" && (
                    <button className="AddCentreButton" onClick={onSubmit}>
                      {formField.instructor_can_be_training_admin_checkbox
                        ? "Update Instructor And Training Center"
                        : "Update Instructor"}
                    </button>
                  )}
                  {type === "ADD" && (
                    <button className="AddCentreButton" onClick={onSubmit}>
                      {formField.instructor_can_be_training_admin_checkbox
                        ? "Add Instructor And Training Center"
                        : "Add Instructor"}
                    </button>
                  )}
                  {type === FOMRS.VIEW ? (
                    ""
                  ) : (
                    <button className="cancelButton" onClick={gotolistingPage}>
                      Cancel
                    </button>
                  )}
                </Grid>
              </Grid>
            </Grid>
          </>
        )}
        <ToastContainer
          position="bottom-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </div>
    </>
  );
};

export default AddInstructor;
